const /* finnish */ characters = "abcdefghijklmnopqrstuvxyz";
const numbers = "1234567890";

const combination = characters + numbers;

const special_characters = "!?#$%&()*+,-./=:;";

export const genPassword = (passwordLength: number = 8): string => {
    let loSpecialChars: number = passwordLength / 10;
    loSpecialChars = (loSpecialChars < 1) ? Math.ceil(loSpecialChars) : Math.floor(loSpecialChars);

    let locationOfSC: Array<number> = [...Array(loSpecialChars)].map(() => {
        return Math.floor(Math.random() * passwordLength);
    });

    let onlyMesh: Array<string> = [...Array(passwordLength)].map((currVal, index) => {
        const currlocationOfSC = locationOfSC.findIndex((currVal) => currVal === index);
        if (currlocationOfSC !== -1) {
            locationOfSC.splice(currlocationOfSC, 1);
            return special_characters[Math.floor(Math.random() * special_characters.length)]
        } else {
            return combination[Math.floor(Math.random() * combination.length)];
        }

    });

    return onlyMesh.reduce((prevVal, currVal) => prevVal + currVal, "");
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/utils/tools.ts